"use strict";function addShortCut$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.addShortCut$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.shortCut.addShortCut";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.7.32"},_a)),exports.addShortCut$=addShortCut$,exports.default=addShortCut$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/shortCut/addShortCut.js
// module id = 989
// module chunks = 106